'use client'

import { GuideProgressBar } from '@doist/marketist'

import { useSelectedLayoutSegment } from 'next/navigation'
import { useProgressOnScroll } from 'services/hooks/use-progress-on-scroll'

import { useTranslation } from '@/app/i18n/client'

type ArticleProgressBarProps = {
    locale: string
}

export function ArticleProgressBar({ locale }: ArticleProgressBarProps) {
    /**
     * If a segment is present, it's assumed the route
     * is productivity-methods/[slug]
     * There's no validation beyond that so if more routes
     * are added, the progress bar will appear
     *
     * You may need to load the blog index in the layout then
     * and access the slug for each article. That seemed excessive
     * for the current state
     */
    const segment = useSelectedLayoutSegment()
    const { t } = useTranslation(locale, 'productivity-methods')
    const progress = useProgressOnScroll()

    if (!segment) {
        return undefined
    }

    return (
        <GuideProgressBar
            current={progress}
            aria-label={t('header.articleProgression', {
                percent: progress.toFixed(0),
            })}
            aria-valuenow={parseInt(progress.toFixed(0), 10)}
        />
    )
}
